"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLayoutBase = exports.AppLayout = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@emotion/core");
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _composeStencilComponent = require("../../utils/composeStencilComponent");
var _AppLayoutContext = require("./AppLayoutContext");
var _AppLayoutMain = require("./AppLayoutMain");
var _AppLayoutTop = require("./AppLayoutTop");
var _constants = require("./constants");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var AppLayoutBase = function AppLayoutBase(_ref) {
  var _childrenNodes$filter;
  var children = _ref.children,
    isHeaderFixed = _ref.isHeaderFixed;
  var childrenNodes = _react.default.Children.toArray(children);
  var _useMemo = (0, _react.useMemo)(function () {
      var usedComponents = {
        topLayoutComponent: null,
        hasSidebar: false
      };
      var _iterator = _createForOfIteratorHelper(childrenNodes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;
          if (! /*#__PURE__*/_react.default.isValidElement(child)) continue;
          if (child.type === _AppLayoutTop.AppLayoutTop) {
            usedComponents.topLayoutComponent = child;
          } else if (child.type === _AppLayoutMain.AppLayoutMain) {
            var _child$props;
            if ((_child$props = child.props) !== null && _child$props !== void 0 && _child$props.children && _react.default.Children.toArray(child.props.children).some(function (c) {
              return /*#__PURE__*/_react.default.isValidElement(c) && c.type === _AppLayoutMain.AppLayoutMainSidebar;
            })) {
              usedComponents.hasSidebar = true;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return usedComponents;
    }, [childrenNodes]),
    topLayoutComponent = _useMemo.topLayoutComponent,
    hasSidebar = _useMemo.hasSidebar;
  return (0, _core.jsx)(_AppLayoutContext.AppLayoutContext.Provider, {
    value: {
      pageHeaderProps: {
        isFixed: isHeaderFixed,
        isFullWidth: true
      },
      topLayoutComponent: topLayoutComponent,
      hasSidebar: hasSidebar,
      isInAppLayout: true
    }
  }, (0, _core.jsx)(_core.Global, {
    styles: {
      'html,body': {
        margin: 0,
        padding: 0
      }
    }
  }), (_childrenNodes$filter = childrenNodes.filter(function (child) {
    return child !== topLayoutComponent;
  })) !== null && _childrenNodes$filter !== void 0 ? _childrenNodes$filter : null);
};
exports.AppLayoutBase = AppLayoutBase;
var AppLayout = (0, _composeStencilComponent.composeStencilComponent)({
  baseComponent: AppLayoutBase,
  displayName: 'AppLayout',
  description: 'Root element with context to wrap AppLayout subcomponents',
  propTypes: {
    children: _stencilReactDesc.PropTypes.node.description('Contains AppLayout components to build the proper layout'),
    isHeaderFixed: _stencilReactDesc.PropTypes.bool.description('Determines whether to fix the header to the top of the page.')
  },
  defaultProps: _constants.appLayoutDefaultProps
});
exports.AppLayout = AppLayout;